import React, { Component } from 'react';
import { Link } from 'react-router';

import './style.css';

import StudentSideBar from '../StudentSideBar';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import StudentAppBar from '../StudentAppBar';
import ShareButton from '../ShareButton';

class StudentCareerDetail extends Component {

  state = {
    isOpen: window.innerWidth < 980 ? false : true,
  }

  createMarkup = (data) => {
    if (data) {
      return { __html: data };
    } else {
      return { __html: <p></p> };
    }
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  render() {
    const data = this.props.location.state.data
    const { isOpen } = this.state

    return (
      <MuiThemeProvider>
        <div className="dash-container">
          <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

          <div className="dash-content">
            <StudentAppBar title="Career Details" toggleSidebar={this.toggleSidebar} router={this.props.router} />
            <div className="container">
              <section className="dash-alert-details">
                <nav className="mb-4">
                  <ol className="breadcrumb alert-breadcrumb">
                    <li className="breadcrumb-item"><Link to="/careers">Careers</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">{data.title}</li>
                  </ol>
                </nav>

                <div className="row">
                  <div className="col-lg-3 mb-3">
                    <div className="nav flex-column nav-pills alert-tab" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a className="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#info" role="tab">About</a>
                      <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#process" role="tab">Typical Opportunities</a>
                      <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#eligible" role="tab">Qualities</a>
                    </div>
                    <ShareButton />
                  </div>
                  <div className="col-lg-9 pl-lg-0">
                    <div className="tab-content alert-tab-content" id="v-pills-tabContent">
                      <div className="tab-pane fade show active" id="info">
                        {data.domain ? <div dangerouslySetInnerHTML={this.createMarkup(data.domain)}></div> : ""}
                      </div>
                      <div className="tab-pane fade" id="process">
                        {data.opportunities ? <div dangerouslySetInnerHTML={this.createMarkup(data.opportunities)}></div> : ""}
                      </div>
                      <div className="tab-pane fade" id="eligible">
                        {data.skills ? <div dangerouslySetInnerHTML={this.createMarkup(data.skills)}></div> : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default StudentCareerDetail;



/** WEBPACK FOOTER **
 ** ./src/components/CareerDetail/index.js
 **/